import Immutable from 'immutable';

const initialState = Immutable.fromJS({
  subscriptionPrice: null,
  stripePlanId: null,
  stripePubKey: null,
  productName: null,
  userPaymentStatus: null,
  userPaymentMsg: null,
  updateCardStatus: null,
  accessType: null,
  logo: null,
  plans: null,
  extraPlans: null,
  extraBenefits: null,
  productName: null,
  stripeCustomerOwner: null,
  siteCheckout: null,
  salesPage: null,
  onboardingGoalOptions: [],
  payPalBackupMessage: null
});

const setProductInfo = (action, state) => {
  if(!action.productInfo){
    return state;
  }

  const {
    accessType,
    checkoutMethod,
    logo,
    plans,
    extraPlans,
    extraBenefits,
    productName,
    stripeCustomerOwner,
    stripePubKey,
    siteCheckout,
    salesPage,
    landingPageCustomizations,
    customCheckoutSuccessURL,
    payPalBackupMessage,
    temp_hana_checkoutMethod
    //temp code; used so mobile app can link out to sales page
    //since mobile app doesn't support showing euro sign
    //but salesPage still needs to use stripe_checkout_2 since
    //Hana is in Europe and we need to be SCA-compliant
  } = action.productInfo;

  return state.set('accessType', accessType)
    .set('checkoutMethod', checkoutMethod)
    .set('logo', logo)
    .set('plans', Immutable.fromJS(plans))
    .set('extraPlans', Immutable.fromJS(extraPlans))
    .set('extraBenefits', Immutable.fromJS(extraBenefits))
    .set('productName', productName)
    .set('stripeCustomerOwner', stripeCustomerOwner)
    .set('stripePubKey', stripePubKey)
    .set('landingPageCustomizations', Immutable.fromJS(landingPageCustomizations))
    .set('siteCheckout', Immutable.fromJS(siteCheckout))
    .set('salesPage', Immutable.fromJS(salesPage))
    .set('customCheckoutSuccessURL', customCheckoutSuccessURL)
    .set('payPalBackupMessage', payPalBackupMessage || null)
    .set('temp_hana_checkoutMethod', temp_hana_checkoutMethod)
}

const setOnboardingOptions = (action, state) => {
  if(!action.onboardingGoalOptions){
    return state;
  }

  return state.set('onboardingGoalOptions', action.onboardingGoalOptions)
}

const setUserPaymentResult = (action, state) => {
  const { success, err } = action;
  if(success){
    return state.set('userPaymentStatus', 'success');
  } else if(err){
    return state.set('userPaymentStatus', 'err')
                .set('userPaymentMsg', err);
  }
}

const setUpdateCardResult = (action, state) => {
  const { success, err } = action;
  if(success){
    return state.set('updateCardStatus', 'success');
  } else if(err){
    return state.set('updateCardStatus', 'err');
  }
}

module.exports = function(state = initialState, action = {}) {
  switch(action.type) {
    case 'SET_PRODUCT_INFO': {
      return setProductInfo(action, state);
    }

    case 'SET_USER_PAYMENT_RESULT': {
      return setUserPaymentResult(action, state);
    }

    case 'SET_UPDATE_CARD_RESULT': {
      return setUpdateCardResult(action, state);
    }

    case 'SET_ONBOARDING_OPTIONS': {
      return setOnboardingOptions(action, state);
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/paymentReducer.js